import React, { Component } from 'react';
import {
  // CircularProgress,
  TextField,
  Button,
  // Card,
  // Icon,
  // Typography,
  // withStyles
} from '@material-ui/core';
import ReCAPTCHA from "react-google-recaptcha";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './App.css';
import Webcam from "react-webcam";
import axios from 'axios';
import WebcamCapture from './WebcamCapture';
import Box from '@mui/material/Box';
// import Button as ButtomMaterial from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import JSZip from 'jszip';

var Spinner = require('react-spinkit');
var QRCode = require('qrcode.react');

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const styles = theme => ({
  root: {
  },
});

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      no_id: '',
      nama_lengkap: '',
      no_hp: '',
      email: '',
      // photo: 'data:image/jpeg;base64,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',
      photo: '',
      kode_perusahaan: '',
      no_id_helper: '',
      nama_lengkap_helper: '',
      no_hp_helper: '',
      email_helper: '',
      photo_helper: '',
      kode_perusahaan_helper: '',
      is_no_id_error: false,
      is_nama_lengkap_error: false,
      is_no_hp_error: false,
      is_email_error: false,
      is_photo_error: false,
      is_kode_perusahaan_error: false,
      is_camera_active: false,
      isModalShow: false,
      modalTitle: '',
      modalContent: '',
      captcha_value: '',
      no_registrasi: '',
    }

    this.handleClick = this.handleClick.bind(this);
  }


  changePage(toPage) {
    this.setState({ page: 99 });

    setTimeout(() => {
      this.setState({ page: toPage });
    }, 200)
  }


  resizeImage(base64Str, maxWidth = 400, maxHeight = 350) {
    return new Promise((resolve) => {
      let img = new Image()
      img.src = base64Str
      img.onload = () => {
        let canvas = document.createElement('canvas')
        const MAX_WIDTH = maxWidth
        const MAX_HEIGHT = maxHeight
        let width = img.width
        let height = img.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }
        canvas.width = width
        canvas.height = height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, width, height)
        resolve(canvas.toDataURL())
      }
    })
  }

  getBase64 = file => {
    return new Promise(resolve => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  handleUploadChange(e) {
    console.log(e)
    // let { file } = this.state;

    let file = e.target.files[0];

    this.getBase64(file)
      .then(result => {
        // file["base64"] = result;
        this.resizeImage(result, 720, 720).then(res => {
          this.setState({
            photo: res,
            is_photo_error: false,
            photo_helper: '',
            // file
          });
        })
      })
      .catch(err => {
        console.log(err);
      });

    // this.setState({
    //   file: e.target.files[0]
    // });
  }

  handleClick(e) {
    this.refs.fileUploader.click();
  }

  downloadQRCode = () => {
    let canvas = document.getElementById("qrcode");

    const linkSource = canvas.toDataURL();
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = "QRCode.png";
    downloadLink.click();
  };

  captureFromCamera(base64) {
    this.resizeImage(base64, 720, 720).then(res => {
      this.setState({
        page: 1,
        photo: res,
        is_photo_error: false,
        photo_helper: '',
        is_camera_active: false,
        // file
      });
    })
  }

  render() {
    // console.log(this)
    if (this.state.is_camera_active) {
      return (
        <div id="wizard_container">
          <div id="middle-wizard" style={{ paddingTop: 16, paddingBottom: 8 }}>
            <div className="row">
              <WebcamCapture parent={this}
                captureFromCamera={this.captureFromCamera} />
            </div>
          </div>
        </div>
      )
    } else if (this.state.page === 99) {
      return (
        <div id="wizard_container">
          <div id="middle-wizard">
            <Spinner name='three-bounce' />
          </div>
        </div>
      )
    } else if (this.state.page === 1) {
      return (
        <div id="wizard_container">
          <div id="middle-wizard">
            <div className="step">
              <h3 className="main_question"><strong>1/3</strong>Silahkan isi form berikut dengan
                benar.</h3>
              <div className="row">
                <div className="col-md-12">
                  <TextField
                    error={this.state.is_no_id_error}
                    helperText={this.state.no_id_helper}
                    id="no_id"
                    className="form-control required"
                    label="NIK *"
                    placeholder="NIK *"
                    margin="normal"
                    fullWidth
                    type="number"
                    value={this.state.no_id}
                    onBlur={(evt) => {
                      if (evt.target.value.trim() === "") {
                        this.setState({ is_no_id_error: true, no_id_helper: 'Harus diisi.' })
                      } else {
                        this.setState({ is_no_id_error: false, no_id_helper: '' })
                      }
                    }}
                    onChange={(evt) => this.setState({ no_id: evt.target.value })}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <TextField
                    error={this.state.is_nama_lengkap_error}
                    helperText={this.state.nama_lengkap_helper}
                    id="nama"
                    className="form-control required"
                    label="Nama (Sesuai KTP) *"
                    placeholder="Nama (Sesuai KTP) *"
                    margin="normal"
                    fullWidth
                    type="text"
                    value={this.state.nama_lengkap}
                    onBlur={(evt) => {
                      if (evt.target.value.trim() === "") {
                        this.setState({ is_nama_lengkap_error: true, nama_lengkap_helper: 'Harus diisi.' })
                      } else {
                        this.setState({ is_nama_lengkap_error: false, nama_lengkap_helper: '' })
                      }
                    }}
                    onChange={(evt) => this.setState({ nama_lengkap: evt.target.value })}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <TextField
                    error={this.state.is_email_error}
                    helperText={this.state.email_helper}
                    id="email"
                    className="form-control required"
                    label="Email *"
                    placeholder="Email *"
                    margin="normal"
                    fullWidth
                    type="email"
                    value={this.state.email}
                    onBlur={(evt) => {
                      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                      if (evt.target.value.trim() === "") {
                        this.setState({ is_email_error: true, email_helper: 'Harus diisi.' })
                      } else if (!re.test(evt.target.value.trim())) {
                        this.setState({ is_email_error: true, email_helper: 'Email tidak valid' })
                      } else {
                        this.setState({ is_email_error: false, email_helper: '' })
                      }
                    }}
                    onChange={(evt) => this.setState({ email: evt.target.value })}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <TextField
                    error={this.state.is_no_hp_error}
                    helperText={this.state.no_hp_helper}
                    id="no_hp"
                    className="form-control required"
                    label="No. Handphone *"
                    placeholder="No. Handphone *"
                    margin="normal"
                    fullWidth
                    type="number"
                    value={this.state.no_hp}
                    onBlur={(evt) => {
                      if (evt.target.value.trim() === "") {
                        this.setState({ is_no_hp_error: true, no_hp_helper: 'Harus diisi.' })
                      } else {
                        this.setState({ is_no_hp_error: false, no_hp_helper: '' })
                      }
                    }}
                    onChange={(evt) => this.setState({ no_hp: evt.target.value })}
                  />
                </div>
              </div>
              <div className="row" style={{ paddingTop: 20 }}>
                <div className="col-md-12">
                  {
                    this.state.photo &&
                    <div style={{ paddingBottom: 8 }}>
                      <img src={this.state.photo} style={{ height: 100 }} />
                    </div>
                  }
                  {
                    this.state.photo
                      ?
                      <div>
                        <Button className="tombol" variant="contained" onClick={() => {
                          this.setState({ photo: null })
                        }}>Hapus Foto</Button>
                      </div>
                      :
                      <div>
                        <label for="contained-button-file">
                          <Button className="tombol" variant="contained" onClick={this.handleClick}>Unggah Foto Diri</Button>&nbsp;
                        </label>
                        <Button className="tombol" variant="contained" onClick={() => this.setState({ is_camera_active: true })}>Ambil Foto Diri dari Kamera</Button>
                      </div>
                  }

                  <input
                    ref="fileUploader"
                    style={{ display: 'none' }}
                    accept="image/*"
                    // className={classes.input}
                    id="contained-button-file"
                    multiple
                    type="file"
                    onChange={this.handleUploadChange.bind(this)}
                  />

                </div>
                {
                  (this.state.is_photo_error) && <div style={{ paddingTop: 2 }}>
                    <span style={{ fontSize: 12, color: 'red' }}>{this.state.photo_helper}</span>
                  </div>
                }

              </div>
            </div>
          </div>
          <div id="bottom-wizard">
            <button type="button" name="forward" className="forward" onClick={() => {
              const { is_no_id_error, is_nama_lengkap_error, is_no_hp_error, is_email_error, no_id, nama_lengkap, no_hp, email, photo } = this.state;
              if (!is_no_id_error && !is_nama_lengkap_error && !is_no_hp_error && !is_email_error && photo.trim() !== "") {
                this.changePage(2)
              } else {
                if (no_id.trim() === "") {
                  this.setState({ no_id_helper: "Harus diisi.", is_no_id_error: true })
                } else if (nama_lengkap.trim() === "") {
                  this.setState({ nama_lengkap_helper: "Harus diisi.", is_nama_lengkap_error: true })
                } else if (email.trim() === "") {
                  this.setState({ email_helper: "Harus diisi.", is_email_error: true })
                } else if (no_hp.trim() === "") {
                  this.setState({ no_hp_helper: "Harus diisi.", is_no_hp_error: true })
                } else if (photo.trim() === "") {
                  this.setState({ photo_helper: "Harus unggah Foto Diri.", is_photo_error: true })
                }
              }

            }}>Selanjutnya</button>
          </div>
        </div>
      )
    } else if (this.state.page === 2) {
      return (
        <div id="wizard_container">
          <div id="middle-wizard">
            <div className="step">
              <h3 className="main_question"><strong>2/3</strong>Silahkan isi form berikut dengan
                benar.</h3>
              <div className="row">
                <div className="col-md-4" style={{ display: 'flex', flexDirection: 'row' }}>
                  <div style={{ paddingRight: 8 }}>
                    <img src={this.state.photo} style={{ width: 150 }} />
                  </div>
                </div>
                <div className="col-md-6" style={{ display: 'flex', flexDirection: 'row' }}>
                  <div>
                    <span style={{ fontWeight: 'bold' }}>NIK</span><br />
                    <label style={{ marginBottom: 4 }}>{this.state.no_id}</label><br />
                    <span style={{ fontWeight: 'bold' }}>Nama Lengkap</span><br />
                    <label style={{ marginBottom: 4 }}>{this.state.nama_lengkap}</label><br />
                    <span style={{ fontWeight: 'bold' }}>No. Handphone</span><br />
                    <label style={{ marginBottom: 4 }}>{this.state.no_hp}</label><br />
                    <span style={{ fontWeight: 'bold' }}>Email</span><br />
                    <label style={{ marginBottom: 4 }}>{this.state.email}</label>
                  </div>
                </div>
              </div>
              <div className="row">

              </div>
              <div className="row">
                <div className="col-md-12">
                  <TextField
                    error={this.state.is_kode_perusahaan_error}
                    helperText={this.state.kode_perusahaan_helper}
                    id="kode_perusahaan"
                    className="form-control required"
                    label="Kode Perusahaan *"
                    placeholder="Kode Perusahaan *"
                    margin="normal"
                    fullWidth
                    type="text"
                    value={this.state.kode_perusahaan}
                    onChange={(evt) => this.setState({ kode_perusahaan: evt.target.value })}
                    onBlur={(evt) => {
                      if (evt.target.value.trim() === "") {
                        this.setState({ is_kode_perusahaan_error: true, kode_perusahaan_helper: 'Harus diisi' })
                      } else {
                        this.setState({ is_kode_perusahaan_error: false, kode_perusahaan_helper: '' })
                      }
                    }}
                  />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <ReCAPTCHA
                      sitekey="6LcUZNMSAAAAALI7VnUQrXZBybyg4YPf1qBgHf-q"
                      onChange={(value) => {
                        this.setState({ captcha_value: value })
                      }}
                    />
                  </div>
                </div>
                <Modal
                  open={this.state.isModalShow}
                  onClose={() => {
                    this.setState({ isModalShow: false })
                  }}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      {this.state.modalTitle}
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                      {this.state.modalContent}
                    </Typography>
                    <button style={{ marginTop: 16 }} type="button" className="tombol" onClick={() => {
                      this.setState({ isModalShow: false, modalTitle: '', modalContent: '', })
                    }}>OK </button>
                  </Box>
                </Modal>
              </div>
            </div>
          </div>
          <div id="bottom-wizard">
            <button type="button" name="backward" className="backward" onClick={() => {
              this.changePage(1)
            }}>Kembali </button>&nbsp;
            <button type="tombol" name="backward" className="submit" onClick={() => {
              if (this.state.kode_perusahaan.trim() !== '') {
                axios.post('http://dapurandroid.com:9000/app/registrasi_tamu', {
                  nid: this.state.no_id,
                  nama_lengkap: this.state.nama_lengkap,
                  email: this.state.email,
                  no_hp: this.state.no_hp,
                  kode_perusahaan: this.state.kode_perusahaan,
                  kode: this.state.captcha_value,
                  data_photo: this.state.photo,
                }).then(response => {
                  // console.log(response)
                  this.setState({ no_registrasi: response.data.no_registrasi });
                  this.changePage(3)
                }).catch(e => {
                  // console.log(e.response.data.status_msg)
                  this.setState({ isModalShow: true, modalTitle: 'Bermasalah!', modalContent: e.response.data.status_msg })
                })
              } else {
                this.setState({ is_kode_perusahaan_error: true, kode_perusahaan_helper: 'Kode Perusahaan harus diisi.' })
              }
              // this.changePage(3)
            }}>Daftar</button>
          </div>
        </div>
      )
    } else {
      return (
        <div id="wizard_container">
          <div id="middle-wizard">
            <div className="step">
              <h3 className="main_question"><strong>3/3</strong>Anda telah berhasil. Silahkan cetak dan tunjukan QR Code di bawah ini saat anda berkunjung.</h3>
              <div className="row" style={{ justifyContent: 'center' }}>
                <QRCode id={'qrcode'} size={300} value={this.state.no_registrasi} />
              </div>
            </div>
          </div>
          <div id="bottom-wizard">
            <button name="process" className="tombol" onClick={this.downloadQRCode}>Unduh</button>&nbsp;
            <button name="process" className="tombol" onClick={() => {
              this.setState({
                no_id: '',
                nama_lengkap: '',
                no_hp: '',
                email: '',
                photo: '',
                kode_perusahaan: '',
                no_id_helper: '',
                nama_lengkap_helper: '',
                no_hp_helper: '',
                email_helper: '',
                photo_helper: '',
                kode_perusahaan_helper: '',
                is_no_id_error: false,
                is_nama_lengkap_error: false,
                is_no_hp_error: false,
                is_email_error: false,
                is_photo_error: false,
                is_kode_perusahaan_error: false,
                is_camera_active: false,
                isModalShow: false,
                modalTitle: '',
                modalContent: '',
                captcha_value: '',
                no_registrasi: '',
              })
              this.changePage(1)
            }}>Daftar Lagi</button>
          </div>
        </div>
      )
    }

  }
}

export default App;
